import classNames from 'classnames'
import React from 'react'

import { SurfaceColorType, TextColorType } from '@ui/design-system/colors/colors'
import { RadiusType } from '@ui/design-system/radius'
import { SpacingType } from '@ui/design-system/spacing'
import { IconFCType } from '@ui/icons/types'

import { Box } from '@shared/components/Box'

import styles from './FeatureIcon.module.scss'

type Size = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'

interface Props {
  icon: IconFCType
  bg: SurfaceColorType
  color?: TextColorType
  onClick?: () => void
  size?: Size
}

export const FeatureIcon: React.FC<Props> = (props) => {
  const { icon: Icon, onClick, bg } = props
  const { color = 'text-inverse-black-neutral' } = props
  const { size = 'md' } = props

  const iconSize: Record<Size, number> = { xxs: 16, xs: 20, sm: 24, md: 28, lg: 32, xl: 40 }

  const radius: Record<Size, RadiusType> = {
    xxs: 'x6',
    xs: 'x8',
    sm: 'x10',
    md: 'x12',
    lg: 'x16',
    xl: 'x16',
  }

  const spacing: Record<Size, SpacingType> = {
    xxs: 'x4',
    xs: 'x6',
    sm: 'x8',
    md: 'x10',
    lg: 'x12',
    xl: 'x12',
  }

  return (
    <Box
      style={{ width: 'fit-content' }}
      className={classNames(styles.featureIcon, styles[`size-${size}`])}
      bg={bg}
      onClick={onClick}
      p={spacing[size]}
      radius={radius[size]}
    >
      <Icon size={iconSize[size]} color={color} />
    </Box>
  )
}
